"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Information() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="19996" id="the-ostara-philosophy" ref={ref} className="bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-5">
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-primary rounded-full blur-3xl" />
        <div className="absolute top-1/2 -right-24 w-64 h-64 bg-accent rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid grid-cols-12 gap-8">
          <div className={`col-span-12 md:col-span-10 md:col-start-2 lg:col-span-8 lg:col-start-3 text-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold mb-6 tracking-tight text-primary">
              The Ostara Philosophy: Rooted Support for Your Renewal
            </h2>

            {}
            <div className="flex justify-center mb-8">
              <svg width="120" height="12" viewBox="0 0 120 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-accent">
                <path d="M2 6C20 6 30 2 40 2C50 2 60 10 70 10C80 10 90 6 100 6C110 6 115 8 118 8" stroke="currentColor" strokeWidth="3" strokeLinecap="round" className="opacity-80" />
              </svg>
            </div>

            <p className="text-lg md:text-xl font-sans text-foreground/80 leading-relaxed mb-10">At Ostara Counseling, our work is rooted in presence, collaboration, and respect for each person’s unique path. Our team of LMHCs and clinicians brings a range of perspectives and specialties, working together to provide care that is both thoughtful and practical—supporting real, sustainable growth over time.</p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Button asChild size="lg" className="bg-accent text-accent-foreground hover:bg-accent/90 hover:-translate-y-1 transition-all duration-300 shadow-lg hover:shadow-accent/20 min-w-[200px]">
                <Link to="/TheOstaraTeamPage">
                  Meet Our Team
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
              
              <Button asChild variant="outline" size="lg" className="border-primary/20 text-primary hover:bg-primary/5 hover:text-primary hover:border-primary min-w-[200px] bg-transparent">
                
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}